import { useEffect, useRef } from 'react';

export const useDelayedCall = callback => {
	const savedCallback = useRef();
	const timeoutId = useRef();

	// Remember the latest callback.
	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	return function changeOnDelay(param) {
		// Clear any existing timeout to make sure we only trigger the delay once.
		clearTimeout(timeoutId.current);

		function tick() {
			savedCallback.current(param);
		}

		// Set a new timeout to trigger the delay.
		timeoutId.current = setTimeout(tick, 1000);
	};
};
